import { useCallback } from "react";
import { getErrorMessageFromApiError } from "@fmc-digital/assets";
import { getCurrentLanguage } from "@fmc-digital/i18n";

export function useApiErrorMessage() {
  return useCallback((error: unknown): string => {
    try {
      const lang = getCurrentLanguage() ?? "en";
      return getErrorMessageFromApiError(error as never, lang);
    } catch {
      return getErrorMessageFromApiError(error as never, "en");
    }
  }, []);
}
